'use strict';

import modalDirective from 'brg/rest/buttons/modal';
import resolveUsers from 'utils/resolve/users';

import template from './template.html';

export default modalDirective({
	template: template,
	controller: controller,
	resolve: {
		users: resolveUsers,
	}
});


function controller($scope, $http) {
	'ngInject';

	$scope.submitting = false;
	$scope.errors = null;
	// Initially for MVP we are not supporting designation types
	$scope.profileType = 0;

	$scope.submitData = function() {
		if ($scope.submitting) return;
		$scope.submitting = true;

		let url, data;

		console.log($scope);

		if ($scope.profileType === 0) {
			url = '/api/admin/events/add_user_stakeholder_to_event_configuration';
			data = {
				conf_id: $scope.$context.confId,
				target_user_id: $scope.selectedUser.uuid,
				send_checkins: $scope.sendCheckins,
			};
			switch ($scope.phoneType) {
				case 1:
					data.alt_phone_number = {
					    value: $scope.customPhoneNumber,
					    region: 'US'
					}
					break;
			}
		} else {
			return;
		}

		$http({
			method: 'POST',
			url: url,
			data: data,
		}).then((response) => {
			$scope.$close(response.data);
		}, (error) => {
			console.error(error);
			$scope.errors = error.data;
		}).finally(() => {
			$scope.submitting = false;
		});
	}
}
